import { PrimaryButton, Stack, Text } from '@fluentui/react';
import { PanelType } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataContratDeReservation } from '../../data/DataContratDeReservation';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUISeparator } from '../EUI/EUISeparator';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheCorrigerReservation extends Component {

    static defaultProps = {
        contrat: {},
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSolve: () => null
    };

    static defaultState = {
        estDateSignatureEiffageElectroniqueContraliaRenseignee: false,
        idContacts: [],
        logs: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheCorrigerReservation.defaultState };
    }

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Analyse en cours du contrat de réservation..."
        });

        const { contrat } = this.props;
        const { dateDeSignatureEiffageManuelle, dateSignatureEiffageElectronique, dateSignatureElectronique, idOperation, idReservation, nomDocument, rowGUID } = contrat;
        const objet = { dateDeSignatureEiffageManuelle, dateSignatureEiffageElectronique, dateSignatureElectronique, idOperation, idReservation, nomDocument, rowGUID };

        DataContratDeReservation._chargementSignatureElectroniqueInformation(objet).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const { estDateSignatureEiffageElectroniqueContraliaRenseignee, idContacts, logs } = responseFetch.reponseAPIobjet;

                let state = { logs, estDateSignatureEiffageElectroniqueContraliaRenseignee };
                if (idContacts.length !== 0)
                    state.idContacts = idContacts;

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onOpen = () => {
        const { contrat } = this.props;
        this.setState({ ...FicheCorrigerReservation.defaultState });
        if (contrat)
            this._chargementDonnees();
    };

    _onRenderLog = (log, key) => {
        const { message, type } = log;

        let styles = {};
        let span = message;

        switch (type) {
            case "error":
                styles = { root: { color: "red" } };
                span = `/!\\ ${span}`;
                break;
            case "ok":
                styles = { root: { color: "green" } };
                span = `Ok: ${span}`
                break;
            case "strong":
                styles = { root: { fontWeight: 700 } };
                break;
            case "warning":
                styles = { root: { color: "darkorange" } };
                span = `/?\\ ${span}`;
                break;
            default: break;
        }

        return <Text key={key} styles={styles}>{span}</Text>;
    };

    _onSolve = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Synchronisation des données en cours..."
        });

        const { contrat, onSolve } = this.props;
        const { idOperation, idReservation, rowGUID } = contrat;
        const { idContacts } = this.state;

        const objet = { idContacts, idOperation, idReservation, rowGUID };

        DataContratDeReservation._corrigerSignatureElectroniqueParEI(objet).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                onSolve();
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    render = () => {

        const { contrat, isOpen, onDismiss } = this.props;
        const { dateDeSignatureEiffageManuelle, dateSignatureClientManuelle, dateSignatureEiffageElectronique, dateSignatureElectronique, nomClient, nomDocument, nomCommercial, prixHT, typeDocument } = contrat;
        const { estDateSignatureEiffageElectroniqueContraliaRenseignee, logs } = this.state;

        return <EUIPanel
            customPrimaryButtons={[<PrimaryButton key="solve" onClick={this._onSolve} disabled={!estDateSignatureEiffageElectroniqueContraliaRenseignee}>Corriger</PrimaryButton>]}
            headerText="Analyse et correction"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            type={PanelType.medium}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <EUIDetailsList
                columns={[{ key: "label", minWidth: 175, maxWidth: 175 }, { key: "value" }]}
                compact
                hideCommandBar
                hideHeader
                items={[
                    { label: "Opération", value: nomCommercial },
                    { label: "Document", value: nomDocument },
                    { label: "Type de document", value: typeDocument },
                    { label: "Clients", value: nomClient },
                    { label: "Prix HT", value: prixHT ? `${Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(contrat.prixHT).toFixed(2), false, 2)} €` : "" },
                    { label: "Date signature electronique", value: dateSignatureElectronique ? Scriba.date().stringDateFormatCourt(dateSignatureElectronique) : "non renseignée" },
                    { label: "Date signature client manuelle", value: dateSignatureClientManuelle ? Scriba.date().stringDateFormatCourt(dateSignatureClientManuelle) : "non renseignée" },
                    { label: "Date signature EI électronique", value: dateSignatureEiffageElectronique ? Scriba.date().stringDateFormatCourt(dateSignatureEiffageElectronique) : "non renseignée" },
                    { label: "Date signature EI manuelle", value: dateDeSignatureEiffageManuelle ? Scriba.date().stringDateFormatCourt(dateDeSignatureEiffageManuelle) : "non renseignée" },
                ]}
                wrapInScrollablePane={false}
            />

            {Array.isArray(logs) && logs.length > 0 &&
                <Stack>
                    <EUISeparator />
                    {logs.map((log, index) => this._onRenderLog(log, index))}
                    <EUISeparator />
                </Stack>
            }

        </EUIPanel>;

    };

};